/* @flow */

const BIAS_TOKEN = 'dlb-jwt';

export function getToken() {
  return sessionStorage.getItem(BIAS_TOKEN) || '';
}

export function setToken(token: string) {
  sessionStorage.setItem(BIAS_TOKEN, token);
}

export function removeToken() {
  sessionStorage.removeItem(BIAS_TOKEN);
}
